<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "layout-dashboard",

  data() {
    return {
      loading: this.$buefy.loading.open({ container: null }),
      updateInterval: null,
      navigation: false
    };
  },

  created() {
    // let metaThemeColor = document.querySelector("meta[name=theme-color]");
    // metaThemeColor.setAttribute("content", "#f4f8fb");
    // console.log(metaThemeColor);
    // this.getUpdatedData();
    // console.log("DASHBOARD: created");
    if (!this.isConfig) {
      this.forceClientUpdate();
    }
    this.toggleLoading();
  },

  beforeDestroy() {
    // console.log("DASHBOARD: beforeDestroy");
    this.setAutoUpdates(false);
    this.loading.isActive = false;
    clearInterval(this.updateInterval);
  },

  watch: {
    isConfig() {
      this.toggleLoading();
    },
    updateAuto() {
      this.setupUpdatesInterval();
    }
  },

  computed: {
    navToggleClass() {
      return this.navigation ? "navigation--true" : "";
    },
    ...mapGetters("config", ["isConfig", "updateAuto", "user"])
  },

  methods: {
    toggleLoading() {
      if (!this.isConfig) {
        this.loading.isActive = true;
      } else {
        this.loading.isActive = false;
      }
    },
    setupUpdatesInterval() {
      // console.log("setupUpdatesInterval");
      if (this.updateAuto) {
        console.log("SET INTERVAL");
        this.updateInterval = setInterval(
          function() {
            console.log("intervalClientUpdate");
            this.getUpdatedData();
          }.bind(this),
          60000
        );
      } else {
        console.log("DISABLE INTERVAL");
        clearInterval(this.updateInterval);
      }
    },
    toggleNavigation() {
      this.navigation = this.navigation ? false : true;
    },
    closeNavigation() {
      if (this.navigation) this.navigation = false;
    },
    ...mapActions("authentication", ["logout"]),
    ...mapActions("config", [
      "forceClientUpdate",
      "setAutoUpdates",
      "getUpdatedData"
    ])
  }
};
</script>

<template>
  <div class="layout-dashboard" :class="navToggleClass">
    <!-- <app-header /> -->
    <template v-if="isConfig">
      <div id="app__navigation" @click="closeNavigation()">
        <div class="exitNavigation"></div>
        <div class="wrapper">
          <div id="app__branding">
            <router-link :to="{ name: 'home' }" class="logo">
              <img class="img" src="../assets/img/rm.svg" alt="" />
              <h1 class="text">iBranch</h1>
            </router-link>
          </div>
          <nav>
            <ul>
              <li>
                <router-link :to="{ name: 'home' }">
                  <!-- <b-icon icon="map-marker-alt" size="is-small"></b-icon> -->
                  <span>Stores</span>
                </router-link>
              </li>
              <!-- <li>
                <router-link :to="{ name: 'about' }">
                  <b-icon icon="map-marker-alt" size="is-small"></b-icon>
                  <span>About</span>
                </router-link>
              </li> -->
              <li>
                <router-link :to="{ name: 'account' }">
                  <!-- <b-icon icon="map-marker-alt" size="is-small"></b-icon> -->
                  <span>Account</span>
                </router-link>
              </li>
            </ul>
          </nav>

          <div v-if="isConfig" class="">
            <a class="user" href="#" @click.prevent="logout" title="Logout">
              <!-- <i class="ibranchfont ibranchfont-user is-size-4"></i> -->
              <b-icon icon="sign-out-alt" size="is-small"></b-icon>
              <span class="display_name">{{ user.display_name }}</span>
            </a>
          </div>
        </div>
      </div>
      <div id="app__view">
        <div class="exitNavigation" @click="closeNavigation()"></div>
        <div class="topbar">
          <div id="toggle-navigation" @click="toggleNavigation()">
            <!-- <i class="ibranchfont ibranchfont-menu-variant is-size-3"></i> -->
            <i class="ibranchfont ibranchfont-menu-solid is-size-4"></i>
          </div>
        </div>
        <slot />
      </div>
    </template>
  </div>
</template>

<style lang="scss">
.layout-dashboard {
  #toggle-navigation {
    padding: 1rem;
  }
  #app__navigation {
    position: fixed;
    width: 15rem;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 2;
    .wrapper {
      // background-color: #fff;
      padding: 1.75rem;
      padding-top: 3rem;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      nav {
        flex: 1 1 auto;
        ul {
          display: block;
          li {
            display: block;
            &:not(:last-child) {
              margin-bottom: 0.5rem;
            }
            a {
              font-size: 1.5rem;
              font-weight: bold;
              color: #656e82;
              .icon {
                margin-right: 1rem;
              }
            }
          }
        }
      }
    }
    #app__branding {
      padding-bottom: 2.75rem;
      .logo {
        display: flex;
        align-items: center;
        .img {
          max-width: 2.5rem;
          margin-right: 1rem;
        }
        .text {
          color: #4842b7;
          font-size: 1.25rem;
          font-weight: bold;
          line-height: 1.2;
        }
      }
    }
    .user {
      display: flex;
      align-items: center;
      .icon {
        margin-right: 0.75rem;
        font-size: 1.5rem;
      }
      .display_name {
        font-weight: bold;
        font-size: 0.8125rem;
      }
    }
  }
  .topbar {
    display: flex;
  }
}
@media (min-width: 40em) {
  .layout-dashboard {
    #app__view {
      padding: 1rem;
    }
  }
}
@media (max-width: 63.9375em) {
  .layout-dashboard #app__navigation,
  .layout-dashboard #app__navigation:before,
  .layout-dashboard #app__view,
  .layout-dashboard .exitNavigation {
    transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  }
  .layout-dashboard {
    .exitNavigation {
      top: 0;
      left: 0;
      position: absolute;
      width: 100vw;
      height: 100vh;
      // background-color: $body-background-light;
      opacity: 0;
    }
    #app__navigation {
      opacity: 0;
      z-index: 2;
      transform: translateX(2rem);
      &:before,
      &:after {
        position: absolute;
        display: block;
        content: "";
        top: 0;
        left: 0;
        height: 100vh;
        background-color: $body-background-light;
      }
      &:before {
        width: 100vw;
        background-color: rgb(176, 172, 255);
        transform: translateX(50%);
      }
      &:after {
        width: 50vw;
        min-width: 18rem;
      }
      .wrapper {
        position: relative;
        z-index: 1;
      }
    }
    #app__view {
      z-index: 3;
      // background-color: #fff;
    }
  }
  .layout-dashboard.navigation--true {
    #app__navigation {
      opacity: 1;
      transform: translateX(0);
    }
    #app__view {
      transform: perspective(10rem) translate3d(16rem, 1rem, -3rem);
      box-shadow: 0 0 2rem 0 rgba(77, 87, 134, 0.25);
      background-color: #fff;
      .exitNavigation {
        z-index: 2;
        opacity: 0.15;
      }
    }
  }
  .layout-dashboard:not(.navigation--true) {
    .exitNavigation {
      pointer-events: none;
    }
    #app__view {
      background-color: $body-background-light;
    }
  }
}
@media (min-width: 64em) {
  .layout-dashboard {
    padding-left: 15rem;
    #toggle-navigation {
      display: none;
    }
    #app__navigation {
      // border-right: 2px solid #f1f2f9;
      box-shadow: 0 0 1rem 0 rgba(77, 87, 134, 0.05);
      .wrapper {
        padding: 2.75rem;
      }
    }
    #app__view {
      padding: 2.75rem;
    }
  }
}
</style>
